import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { LoginFormValues } from 'helpers/formsValidationSchemas/loginScreen';
import { ApiError, ApiResponse, JWTError } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type LoginResponseType = {
  access_token: string;
  refresh_token: string;
};

type Params = LoginFormValues;

export const useLogin = (
  options: MutationOptions<
    LoginResponseType,
    Params,
    AxiosError<ApiError | JWTError>
  >
) =>
  useMutation({
    mutationFn: async (loginData) => {
      const { data } = await api.post<ApiResponse<LoginResponseType>>(
        '/auth/login',
        loginData
      );

      return data.data;
    },

    ...options,
  });
